import { useMemo } from 'react';
import { Badge } from 'react-bootstrap';
import moment from 'moment';

// Gộp ca còn thiếu theo LOẠI ca (tên ca: Ca 5h/8h/12h…): tổng số người thiếu + số slot thiếu.
export function MissingByTemplate({ rows }) {
  const groups = useMemo(() => {
    const map = new Map();
    rows.forEach((row) => {
      const key = row.template_name || row.template_id;
      const g = map.get(key) || { name: key, people: 0, slots: 0 };
      g.people += row.still_missing;
      g.slots += 1;
      map.set(key, g);
    });
    return Array.from(map.values());
  }, [rows]);
  if (groups.length === 0) return null;
  return (
    <div
      className="d-flex flex-wrap gap-1"
      data-testid="bot-missing-by-template"
    >
      {groups.map((g) => (
        <Badge
          key={g.name}
          bg="light"
          text="dark"
          className="border small"
          data-testid={`bot-missing-template-${g.name}`}
        >
          {g.name}: <span className="fw-semibold text-danger">thiếu {g.people} người</span>
          {` · ${g.slots} ca`}
        </Badge>
      ))}
    </div>
  );
}

// Chip từng ca còn thiếu người (kiểu xem Danh sách) — Lịch tuần đã có badge theo ngày nên không lặp.
export function MissingShiftChips({ rows }) {
  if (rows.length === 0) return null;
  return (
    <div
      className="mt-3"
      data-testid="bot-missing-shifts"
    >
      <div className="small fw-semibold mb-1">Ca còn thiếu người ({rows.length})</div>
      <div className="d-flex flex-wrap gap-1">
        {rows.map((row) => (
          <Badge
            key={`missing-${row.template_id}-${row.start_time}`}
            bg="light"
            text="dark"
            className="border small text-wrap text-start"
            style={{ whiteSpace: 'normal' }}
            title="Slot của lịch tuần vẫn chưa đủ người sau khi áp phương án đang chọn"
            data-testid={`bot-missing-shift-${row.template_id}-${row.start_time}`}
          >
            <span className="fw-semibold text-danger">Thiếu {row.still_missing}</span>
            {' · '}
            {row.template_name}
            {' · '}
            {moment(row.start_time).format('ddd DD/MM HH:mm')}-{moment(row.end_time).format('HH:mm')}
            {row.has_boost ? ` · ⚡ ${row.boost_reward_rate_bonus}%` : ''}
          </Badge>
        ))}
      </div>
    </div>
  );
}
